import React, { Component, Fragment, useState, useMemo, useRef, useLayoutEffect, useEffect } from 'react';
import { createPortal } from "react-dom";
import { Input, Table } from 'reactstrap';
import { Link } from 'react-router-dom';
// import { InputNumber } from 'rsuite';
import { Loading } from './LoadingComponent';
import { toMoney, toPerc, toFixed } from './Functions';
import { FixedSizeList as List } from 'react-window';
// import { FixedSizeGrid as Grid } from 'react-window';
import { VariableSizeGrid as Grid } from 'react-window';
// import { FixedSizeGrid as Grid } from 'react-window';

export const RenderDataFrame = (props) => {
    const theader = props.df.columns.map((val,i)=>{
        return(
            <th key={i}>{val.toString()}</th>
        )
    });
    const trows = props.df.index.map((val, i)=>{
        let trowi = null;
        if (props.axis==null || props.axis==0){
            if (props.money_ind!=null && props.money_ind[i]){
                trowi = props.df.data[i].map((val,j)=>{
                    return(
                        <td key={j}>{toMoney(val)}</td>
                    )
                });
            }else if (props.perc_ind!=null && props.perc_ind[i]){
                trowi = props.df.data[i].map((val,j)=>{
                    return(
                        <td key={j}>{toPerc(val)}</td>
                    )
                });

            }else{
                trowi = props.df.data[i].map((val,j)=>{
                    return(
                        <td key={j}>{val.toString()}</td>
                    )
                });
            }
        }else{
                trowi = props.df.data[i].map((val,j)=>{
                    if (props.money_ind!=null && props.money_ind[j]){
                    return(
                        <td key={j}>{toMoney(val)}</td>
                    )
                }else{
                        return(
                            <td key={j}>{val.toString()}</td>
                        )
                    }
                });
            }
        return(
            <tr key={i}>
              <th scope="row">{val}</th>
              {trowi}
            </tr>
        )
    });
    return(
        <Table striped hover style={{fontSize: props.fontsize}} size='sm'>
            <thead>
                <tr>
                    <th>{props.index_name}</th>
                    {theader}
                </tr>
            </thead>
            <tbody>
                {trows}
            </tbody>
        </Table>
    );
};

export const RenderLinkedDataFrame = (props) => {
    const theader = props.df.columns.map((val,i)=>{
        return(
                <th key={i}>
                    <Link to={`/saa/select/${val.toString()}`}>
                    {val.toString()}
                    </Link>
                </th>
        )
    });
    const trows = props.df.index.map((val, i)=>{
        const trowi = props.df.data[i].map((val,j)=>{
            return(
                <td key={j}>{val.toString()}</td>
            )
        });
        return(
            <tr key={i}>
              <th scope="row">{val}</th>
              {trowi}
            </tr>
        )
    });
    return(
        <Table striped hover style={{fontSize: props.fontsize}} size='sm'>
            <thead>
                <tr>
                    <th>{props.index_name}</th>
                    {theader}
                </tr>
            </thead>
            <tbody>
                {trows}
            </tbody>
        </Table>
    );
};


export class RenderInputTable extends Component {
    constructor(props){
        super(props);
        this.handleChange = this.handleChange.bind(this);
    }
    handleChange(i,val,e){
        var new_model = [...this.props.model[this.props.element_id]];
        new_model[i] = {...this.props.model[this.props.element_id][i], [val]:parseFloat(e.target.value)};
        this.props.changeModel(this.props.model_id, {...this.props.model, [this.props.element_id]:new_model});
    };

    render(){
      // === Styles ===
      let header_style, getRowStyle;
      if (this.props.style === "black") {
        header_style = {
          backgroundColor: "black",
          color: "white",
          border: "1px solid white",
          fontWeight:"normal"
        };
        getRowStyle = () => ({
          backgroundColor: "#F0F0F0",
          border: "1px solid white",
          color: "black",
        });
      } else {
        header_style = {
          fontWeight: "bold",
        };
        getRowStyle = (index) => ({
          backgroundColor: index % 2 === 0 ? "#f9f9f9" : "white",
        });
      }
      
        const theader = this.props.columns.map((val,i)=>{
            return(
                <th style={header_style} key={i}>{val.toString()}</th>
            )
        });

        if (this.props.model[this.props.element_id]==null){
            return(
                <div className="container">
                    <div className="row justify-content-center">
                        <></>
                    </div>
                </div>
            );
        }else{
            const trows = this.props.model[this.props.element_id].map((item,i)=>{
                const trowi = this.props.keys.map((val,j)=>{
                    if (this.props.edit){
                        if (this.props.editable!=null && this.props.editable[j]){
                            return(
                                <td style={getRowStyle()} key={j}>
                                    <Input
                                        type='number'
                                        placeholder={item[val]}
                                        defaultValue={parseFloat(item[val].toFixed(2))}
                                        onBlur={(e)=>this.handleChange(i,val,e)}
                                        bsSize='sm' min={0}
                                        max={100}
                                        step={1}
                                    />
                                </td>
                            );
                        }else{
                          if((this.to_money!=null && this.props.to_money[j]) || (this.props.to_money_row!=null && this.props.to_money_row[i] && !isNaN(val))){
                              return(
                              <td style={getRowStyle()} key={j}>{toMoney(item[val])}</td>
                              )
                          }else if((this.props.to_perc!=null && this.props.to_perc[j]) || (this.props.to_perc_row!=null && this.props.to_perc_row[i] && !isNaN(val))){
                              return(
                              <td style={getRowStyle()} key={j}>{toPerc(item[val])}</td>
                              )
                          }else if((this.props.to_fixed!=null && this.props.to_fixed[j]) || (this.props.to_fixed_row!=null && this.props.to_fixed_row[i] && !isNaN(val))){
                              return(
                              <td style={getRowStyle()} key={j}>{toFixed(item[val])}</td>
                              )
                          }else{
                              return(
                              <td style={getRowStyle()} key={j}>{item[val]}</td>
                              )
                          }
                        }
                    }
                    else{
                      if((this.props.to_money!=null && this.props.to_money[j]) || (this.props.to_money_row!=null && this.props.to_money_row[i] && !isNaN(val))){
                          return(
                          <td style={getRowStyle()} key={j}>{toMoney(item[val])}</td>
                          )
                      }else if((this.props.to_perc!=null && this.props.to_perc[j]) || (this.props.to_perc_row!=null && this.props.to_perc_row[i] && !isNaN(val))){
                          return(
                          <td style={getRowStyle()} key={j}>{toPerc(item[val])}</td>
                          )
                      }else if((this.props.to_fixed!=null && this.props.to_fixed[j]) || (this.props.to_fixed_row!=null && this.props.to_fixed_row[i] && !isNaN(val))){
                          return(
                          <td style={getRowStyle()} key={j}>{toFixed(item[val])}</td>
                          )
                      }else{
                          return(
                          <td style={getRowStyle()} key={j}>{item[val]}</td>
                          )
                      }
                    }
                });
                return(
                    <tr key={i}>
                      <th style={getRowStyle()} scope="row">{item.name}</th>
                      {trowi}
                    </tr>
                )
            });
            return(
                <Table style={{fontSize: this.props.fontsize}} size='sm'>
                    <thead>
                        <tr>
                            {theader}
                        </tr>
                    </thead>
                    <tbody>
                        {trows}
                    </tbody>
                </Table>
            );
        }
    }
}

export const RenderTable = ({data, header=null, to_money=null, to_perc=null, to_fixed=null, fontsize=12, table_class='table-striped', to_money_row=null, to_perc_row=null, to_fixed_row=null})=>{
    const trows = data.map((item, i)=>{
        const values = Object.values(item).map((val,j)=>{
            if(val==""){
                return(
                  <td key={j}>{""}</td>
                )
            }else if((to_money!=null && to_money[j]) || (to_money_row!=null && to_money_row[i] && !isNaN(val))){
                return(
                  <td key={j}>{toMoney(val)}</td>
                )
            }else if((to_perc_row==null && to_perc!=null && to_perc[j]) || ((to_perc==null || to_perc[j]) && to_perc_row!=null && to_perc_row[i] && !isNaN(val))){
                return(
                  <td key={j}>{toPerc(val)}</td>
                )
            }else if((to_fixed!=null && to_fixed[j]) || (to_fixed_row!=null && to_fixed_row[i] && !isNaN(val))){
                return(
                  <td key={j}>{toFixed(val)}</td>
                )
            }else{
                return(
                  <td key={j}>{val}</td>
                )
            }
        });
        return(
            <tr key={i}>
                {values}
            </tr>
        )
    });
    let cols = null;
    if (header==null){
        cols = Object.keys(data[0]).map((col,k)=>{
            return(
                <th key={k}>{col}</th>
            );
        });
    }else if(header!=false){
        cols = header.map((col,l)=>{
            return(
                <th key={l}>{col}</th>
            );
        });
    }
    return(
        <Table className={table_class} hover style={{fontSize: fontsize}} size='sm'>
            {header==false
            ? <Fragment></Fragment>
            :<Fragment>
                <thead>
                    <tr>
                        {cols}
                    </tr>
                </thead>
            </Fragment>
            }
            <tbody>
                {trows}
            </tbody>
        </Table>
    );
};


export const FilteredTable = ({ data }) => {
  const [search, setSearch] = useState('');
  const [sortType, setSortType] = useState('asc');
  const [sortField, setSortField] = useState('id');
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  // Filter the data based on search term
  const filteredData = useMemo(() => {
    return data.filter(item => {
      return Object.keys(item).some(key =>
        item[key].toString().toLowerCase().includes(search.toLowerCase())
      );
    });
  }, [data, search]);

  // Sort the data based on sort type and sort field
  const sortedData = useMemo(() => {
    const field = sortField;
    const type = sortType === 'asc' ? 1 : -1;
    return [...filteredData].sort((a, b) => {
      if (a[field] < b[field]) {
        return -1 * type;
      } else if (a[field] > b[field]) {
        return 1 * type;
      } else {
        return 0;
      }
    });
  }, [filteredData, sortField, sortType]);

  // Paginate the data based on current page and rows per page
  const paginatedData = useMemo(() => {
    const startIndex = (currentPage - 1) * rowsPerPage;
    const endIndex = startIndex + rowsPerPage;
    return sortedData.slice(startIndex, endIndex);
  }, [sortedData, currentPage, rowsPerPage]);

  // Handle search input change
  const handleSearchChange = e => {
    setSearch(e.target.value);
  };

  // Handle sort field click
  const handleSortFieldClick = field => {
    setSortField(field);
    setSortType(sortType === 'asc' ? 'desc' : 'asc');
  };

  // Handle pagination change
  const handlePaginationChange = page => {
    setCurrentPage(page);
  };

  // Render the table header
  const renderTableHeader = () => {
    const headers = Object.keys(data[0]);
    return headers.map(header => (
      <th key={header} onClick={() => handleSortFieldClick(header)}>
        {header.toUpperCase()}
        {sortField === header && (
          <span>{sortType === 'asc' ? ' ▲' : ' ▼'}</span>
        )}
      </th>
    ));
  };

  // Render the table body
  const renderTableBody = () => {
    return paginatedData.map(item => (
      <tr key={item.Emisor}>
        <td>{item.Country}</td>
        <td>{item.ISIN}</td>
        <td>{item.Category}</td>
      </tr>
    ));
  };

  return (
    <div>
      <input type="text" value={search} onChange={handleSearchChange} />
      <table>
        <thead>
          <tr>{renderTableHeader()}</tr>
        </thead>
        <tbody>{renderTableBody()}</tbody>
      </table>
      <div>
        <button
          disabled={currentPage === 1}
          onClick={() => handlePaginationChange(currentPage - 1)}
        >
          Previous
        </button>
        <button
          disabled={paginatedData.length < rowsPerPage}
          onClick={() => handlePaginationChange(currentPage + 1)}
        >
          Next
        </button>
      </div>
    </div>
  );
};


function useContainerWidth() {
  const ref = useRef(null);
  const [width, setWidth] = useState(null);

  useEffect(() => {
    if (!ref.current) return;
    setWidth(ref.current.offsetWidth); // set immediately

    const ro = new ResizeObserver(() => {
      setWidth(ref.current.offsetWidth);
    });
    ro.observe(ref.current);

    return () => ro.disconnect();
  }, []);

  return [ref, width];
}

export const useTableContainerWidth = () => {
  const ref = useRef(null);
  const [width, setWidth] = useState(0);

  useLayoutEffect(() => {
    if (!ref.current) return;

    const updateWidth = () => {
      setWidth(ref.current?.offsetWidth || 0);
    };

    // Initial measurement
    updateWidth();

    // Observe size changes
    const observer = new ResizeObserver(() => {
      updateWidth();
    });

    observer.observe(ref.current);

    // Cleanup
    return () => {
      observer.disconnect();
    };
  }, []);

  return [ref, width];
};

const TableTooltip = ({ text, children }) => {
  const [visible, setVisible] = useState(false);
  const [coords, setCoords] = useState({ x: 0, y: 0 });
  const ref = useRef(null);

  useEffect(() => {
    if (visible && ref.current) {
      const rect = ref.current.getBoundingClientRect();
      setCoords({
        x: rect.left + rect.width / 2,
        y: rect.top - 10, // place tooltip above
      });
    }
  }, [visible]);

  return (
    <>
      <span
        ref={ref}
        onMouseEnter={() => setVisible(true)}
        onMouseLeave={() => setVisible(false)}
        style={{ position: "relative", display: "inline-block" }}
      >
        {children}
      </span>

      {visible && text &&
        createPortal(
          <div
            style={{
              position: "fixed",
              top: coords.y,
              left: coords.x,
              transform: "translate(-50%, -100%)",
              backgroundColor: "rgba(0, 0, 0, 0.85)",
              color: "white",
              padding: "6px 10px",
              borderRadius: "6px",
              fontSize: "12px",
              maxWidth: "250px",
              zIndex: 999999,
              pointerEvents: "none",
              boxShadow: "0 4px 10px rgba(0,0,0,0.3)",
              whiteSpace: "normal",
              wordBreak: "break-word",
            }}
          >
            {text}
          </div>,
          document.body
        )}
    </>
  );
};

export const RenderVirtualTable = ({
  data,
  header = null,
  to_money = null,
  to_perc = null,
  to_fixed = null,
  fontsize = 12,
  to_money_row = null,
  to_perc_row = null,
  to_fixed_row = null,
  cell_width = "100px",
  item_size = 40, // row height
  style = "black",
  height = 400,
  factor = 1,
}) => {
  // ✅ Hooks must always run, even if data is empty
  const [containerRef, containerWidth] = useContainerWidth();
  const headerRef = useRef(null);
  // 🧠 Now you can return early
  if (!data || data.length === 0) return null;

  // === Styles ===
  let header_style, getRowStyle;
  if (style === "black") {
    header_style = {
      padding: "8px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: "black",
      color: "white",
      border: "1px solid white",
      fontWeight: "bold",
      textAlign: "center",
    };
    getRowStyle = () => ({
      padding: "4px 8px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: "#F0F0F0",
      border: "1px solid white",
      color: "black",
      textAlign: "center",
    });
  } else {
    header_style = {
      padding: "8px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontWeight: "bold",
      textAlign: "center",
      borderBottom: "1px solid #ccc",
    };
    getRowStyle = (index) => ({
      padding: "4px 8px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: index % 2 === 0 ? "#f9f9f9" : "white",
      textAlign: "center",
      borderBottom: "1px solid #eee",
    });
  }

  // === Column widths ===
  const keys = Object.keys(data[0]);
  const cellWidths = Array.isArray(cell_width)
    ? keys.map((_, i) => cell_width[i] || cell_width.slice(-1)[0])
    : keys.map(() => cell_width);

  const totalWidth = cellWidths.reduce((acc, w) => acc + parseInt(w, 10), 0);
  const gridWidth = Math.min(totalWidth, containerWidth);

  const onScroll = ({ scrollLeft }) => {
    if (headerRef.current) headerRef.current.scrollLeft = scrollLeft;
  };

  // === Cell Renderer ===
  const Cell = ({ columnIndex, rowIndex, style }) => {
    const item = data[rowIndex];
    const key = keys[columnIndex];
    let val = item[key];

    if (val !== "" && !isNaN(val)) {
      if (
        (to_money_row == null && to_money && to_money[columnIndex]) ||
        ((to_money == null || to_money[columnIndex]) &&
          to_money_row &&
          to_money_row[rowIndex])
      ) {
        val = `$${Number(val).toLocaleString()}`;
      } else if (
        (to_perc_row == null && to_perc && to_perc[columnIndex]) ||
        ((to_perc == null || to_perc[columnIndex]) &&
          to_perc_row &&
          to_perc_row[rowIndex])
      ) {
        val = `${(Number(val) * factor).toFixed(2)}%`;
      } else if (
        (to_fixed_row == null && to_fixed && to_fixed[columnIndex]) ||
        ((to_fixed == null || to_fixed[columnIndex]) &&
          to_fixed_row &&
          to_fixed_row[rowIndex])
      ) {
        val = Number(val).toLocaleString();
      }
    }

    return (
      <div
        style={{
          ...style,
          ...getRowStyle(rowIndex),
          width: cellWidths[columnIndex],
          boxSizing: "border-box",
          fontSize: fontsize,
          overflow: "hidden",
          whiteSpace: "normal", // allow multi-line
          wordWrap: "break-word",
          wordBreak: "break-word",
          lineHeight: 1.2,
          padding: "2px 8px"
        }}
        //title={val} // show full text on hover
      >
        <TableTooltip text={val}>
          <span
            style={{
              display: "inline-block",
              maxWidth: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              wordBreak: "break-word",
            }}
          >
            {val}
          </span>
        </TableTooltip>
      </div>
    );
  };

  // === Render ===
  return (
    <div ref={containerRef} className="col-auto mt-4 justify-content-center">
      {/* Scrollable header */}
      {header !== false && (
        <div
          ref={headerRef}
          style={{
            display: "flex",
            overflow: "hidden",
            width: Math.min(totalWidth, gridWidth),
            fontSize: fontsize,
            boxSizing: "content-box",
            paddingRight: 30,
          }}
        >
          <div style={{ display: "flex", width: totalWidth }}>
            {(header ? header : keys).map((col, i) => (
              <div key={i} style={{ ...header_style, width: cellWidths[i] }}>
                {col}
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Virtualized Body */}
      <Grid
        key={keys.join("|")}
        columnCount={keys.length}
        columnWidth={(index) => parseInt(cellWidths[index], 10)}
        rowCount={data.length}
        rowHeight={() => item_size}
        height={Math.min(data.length * item_size, height) + 30}
        width={Math.min(totalWidth, gridWidth) + 30}
        onScroll={onScroll}
      >
        {Cell}
      </Grid>
    </div>
  );
};


const Cell = ({ value, onChange, fontsize }) => {
  const [inputValue, setInputValue] = useState(value);

  useEffect(() => {
    setInputValue(value);
  }, [value]);

  return (
    <input
      type="text"
      value={inputValue}
      onChange={(e) => setInputValue(e.target.value)}
      onBlur={() => onChange(inputValue)}
      style={{
        width: '90%',
        border: '1px solid #ccc',
        borderRadius: '4px',
        padding: '4px',
        fontSize: fontsize - 1,
        textAlign: 'center'
      }}
    />
  );
};


export const RenderEditableVirtualTable = ({
  data,
  change_model, // <- new prop: setter to update data state in parent
  model_id,
  header = null,
  to_money = null,
  to_perc = null,
  to_fixed = null,
  fontsize = 12,
  to_money_row = null,
  to_perc_row = null,
  to_fixed_row = null,
  editable = null,
  cell_width = '100px',
  item_size = 80
}) => {

  const cellWidths = Array.isArray(cell_width)
    ? Object.values(data[0]).map((_, i) => cell_width[i] || cell_width.slice(-1)[0])
    : Object.values(data[0]).map(() => cell_width);

  const handleCellChange = (rowIndex, key, value) => {
    const newData = [...data];
    newData[rowIndex] = { ...newData[rowIndex], [key]: value };
    change_model(model_id, newData);
  };

  const Row = ({ index, style }) => {
    const item = data[index];
    const keys = Object.keys(item);

    const cells = keys.map((key, j) => {
      const val = item[key];

      if (editable!==null && editable[j]){
        return (
          <td 
            key={j}
            style={{
              padding: '8px',
              boxSizing: 'border-box',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: cellWidths[j],
              backgroundColor: index % 2 === 0 ? '#f9f9f9' : 'white',
            }}
            >
            <Cell
              value={val}
              onChange={(newVal) => handleCellChange(index, key, newVal)}
              fontsize={fontsize}
            />
          </td>
        );
      }else{
        let cellContent;
        if (val==''){
          cellContent = val;
        } else if ((to_money != null && to_money[j]) || (to_money_row != null && to_money_row[index] && !isNaN(val))) {
          cellContent = toMoney(val);
        } else if ((to_perc_row==null && to_perc!=null && to_perc[j]) || ((to_perc==null || to_perc[j]) && to_perc_row!=null && to_perc_row[index] && !isNaN(val))) {
          cellContent = toPerc(val);
        } else if ((to_fixed != null && to_fixed[j]) || (to_fixed_row != null && to_fixed_row[index] && !isNaN(val))) {
          cellContent = toFixed(val);
        } else {
          cellContent = val;
        }
  
        return (
          <td
            key={j}
            style={{
              padding: '8px',
              boxSizing: 'border-box',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: cellWidths[j],
              backgroundColor: index % 2 === 0 ? '#f9f9f9' : 'white', // Add striped styling
            }}
          >
            {cellContent}
          </td>
        );
      }
    });

    return (
      <tr style={{ ...style, display: 'flex' }}>
        {cells}
      </tr>
    );
  };

  let cols = null;
  if (header == null) {
    cols = Object.keys(data[0]).map((col, k) => (
      <div
        key={k}
        style={{
          padding: '8px',
          width: cellWidths[k],
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
        <b>{col}</b>
      </div>
    ));
  } else if (header !== false) {
    cols = header.map((col, l) => (
      <div
        key={l}
        style={{
          padding: '8px',
          width: cellWidths[l],
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
        <b>{col}</b>
      </div>
    ));
  }

  return (
    <Table style={{ fontSize: fontsize }}>
      {header === false ? null : (
        <thead>
          <tr style={{ display: 'flex' }}>
            {cols}
          </tr>
        </thead>
      )}
      <tbody>
        <List
          height={Math.min(data.length * 50, 400)}
          itemCount={data.length}
          itemSize={item_size}
          itemData={data}
          innerElementType="tbody"
        >
          {Row}
        </List>
      </tbody>
    </Table>
  );
};

export const RenderVirtualGridTable = ({
  data,
  header = null,
  to_money = null,
  to_perc = null,
  to_fixed = null,
  fontsize = 12,
  to_money_row = null,
  to_perc_row = null,
  to_fixed_row = null,
  cell_width = 100,
  item_size = 80,
  width = 1200
}) => {

  const Cell = ({ columnIndex, rowIndex, style }) => {
    const isHeader = rowIndex === 0;

    let cellContent;

    if (isHeader) {
      // Render header cell
      const headerCellContent = header ? header[columnIndex] : Object.keys(data[0])[columnIndex];

      cellContent = (
        <div
          style={{
            ...style,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: 'white', // Header background color
            fontWeight: 'bold',
          }}
        >
          {headerCellContent}
        </div>
      );
    } else {
      const item = data[rowIndex - 1];
      const colKey = Object.keys(item)[columnIndex];
      const val = item[colKey];

      if (
        (to_money != null && to_money[columnIndex]) ||
        (to_money_row != null && to_money_row[rowIndex - 1] && !isNaN(val))
      ) {
        cellContent = toMoney(val);
      } else if (
        (to_perc != null && to_perc[columnIndex]) ||
        (to_perc_row != null && to_perc_row[rowIndex - 1] && !isNaN(val))
      ) {
        cellContent = toPerc(val);
      } else if (
        (to_fixed != null && to_fixed[columnIndex]) ||
        (to_fixed_row != null && to_fixed_row[rowIndex - 1] && !isNaN(val))
      ) {
        cellContent = toFixed(val);
      } else {
        cellContent = val;
      }

      cellContent = (
        <div
          style={{
            ...style,
            padding: '8px',
            backgroundColor: rowIndex % 2 === 0 ? 'white' : '#f9f9f9', // Add striped styling
            display: 'flex',
            justifyContent: 'center',
            overflow: 'hidden', // Handle overflow
            textOverflow: 'ellipsis', // Optionally add ellipsis for a visual indication of overflow
          }}
        >
          {cellContent}
        </div>
      );
    }

    return cellContent;
  };

  return (
    <div style={{ fontSize: fontsize }}>
      <Grid
        columnCount={Object.keys(data[0]).length}
        columnWidth={cell_width}
        height={400}
        rowCount={data.length + 1}
        rowHeight={item_size}
        width={Math.min(1.05 * cell_width * Object.keys(data[0]).length, width)}
      >
        {Cell}
      </Grid>
    </div>
  );
};
